// Overgezet uit naslag/server/imports/api/types/storage.ts.
export var SparePart;
(function (SparePart) {
    SparePart["aandrijving"] = "aandrijving";
    SparePart["deegwals"] = "deegwals";
    SparePart["doorvoerband"] = "doorvoerband";
    SparePart["eMotor"] = "eMotor";
    SparePart["flexpicker"] = "flexpicker";
    SparePart["infraroodCamera"] = "infraroodCamera";
    SparePart["luchtfilters"] = "luchtfilters";
    SparePart["meelDoseerder"] = "meelDoseerder";
    SparePart["thermostaat"] = "thermostaat";
    SparePart["vacuumGripper"] = "vacuumGripper";
    SparePart["verwarmingselement"] = "verwarmingselement";
    SparePart["watertoevoerklep"] = "watertoevoerklep";
})(SparePart || (SparePart = {}));
export var SubPart;
(function (SubPart) {
    SubPart["aandrijfsnaar"] = "aandrijfsnaar";
    SubPart["armstaaf"] = "armstaaf";
    SubPart["cameraChip"] = "cameraChip";
    SubPart["deksel"] = "deksel";
    SubPart["draaias"] = "draaias";
    SubPart["draaiweerstand"] = "draaiweerstand";
    SubPart["frame"] = "frame";
    SubPart["kabel"] = "kabel";
    SubPart["kogellager"] = "kogellager";
    SubPart["koolstofLaag"] = "koolstofLaag";
    SubPart["lens"] = "lens";
    SubPart["luchtslang"] = "luchtslang";
    SubPart["nonStickBand"] = "nonStickBand";
    SubPart["pakking"] = "pakking";
    SubPart["rotor"] = "rotor";
    SubPart["rubberRing"] = "rubberRing";
    SubPart["scharnier"] = "scharnier";
    SubPart["snaarwiel"] = "snaarwiel";
    SubPart["stekker"] = "stekker";
    SubPart["tandwiel"] = "tandwiel";
    SubPart["trechter"] = "trechter";
    SubPart["warmteSensor"] = "warmteSensor";
    SubPart["warmtewisselaar"] = "warmtewisselaar";
    SubPart["zuignap"] = "zuignap";
})(SubPart || (SubPart = {}));
